export const ERROR_NOT_FOUND = 'NOT FOUND';
export const UNKNOWN_ERROR = 'UNKNOWN ERROR';